module.exports = __webpack_public_path__ + "media/images/home/age@2x-bb39585b8d617739e3140c3a3113ca96.png";